import React from 'react';
import PropTypes from 'prop-types';

class CtnAdDiv extends React.Component {
  constructor() {
    super();
    const position = Math.floor(10000000 + Math.random() * 90000000);
    this.pos = position;
  }

  shouldComponentUpdate() {
    if (this.props.data?.smarked) {
      return false; // No rerender
    }
    return true;
  }

  render() {
    // div-clmb-ctn-207018-127620241
    const { adsCounter = 1 } = this.props;
    // this.state.isClientSide &&
    if (this.props.data && this.props.data.adCode) {
      const newAdObject = {
        id: `div-clmb-ctn-${this.props.data.adCode}-${adsCounter}${this.props
          .data.divId ||
          this.props.data.msid ||
          this.pos}`,
        slot: this.props.data.adCode,
        pos: `${adsCounter}${this.props.data.msid || this.pos}`,
        section: this.props.data.breadCrumb,
        dfpslot: this.props.data.dfpslot,
      };
      const { id, slot, pos, section, dfpslot } = newAdObject;
      return (
        <div className="ctn-workaround-div clearfix">
          {dfpslot && dfpslot.adCode ? (
            <div
              id={id}
              data-slot={slot}
              data-position={pos}
              data-section={section}
              className={`colombia ${this.props.className}`}
              data-dfpslot={dfpslot.adCode}
              data-type="dfp"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: '' }}
              suppressHydrationWarning
              data-ua-type="2"
              data-sp-click="stpPgtn(event)"
              onClick={event => {
                window.stpPgtn(event);
              }}
            />
          ) : (
            <div
              id={id}
              data-slot={slot}
              data-position={pos}
              data-section={section}
              className={`colombia ${this.props.className}`}
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{ __html: '' }}
              suppressHydrationWarning
            />
          )}
        </div>
      );
    }
    return '';
  }
}

CtnAdDiv.propTypes = {
  data: PropTypes.shape({
    adCode: PropTypes.number.isRequired,
    msid: PropTypes.string.isRequired,
    divId: PropTypes.string,
    breadCrumb: PropTypes.string.isRequired,
    smarked: PropTypes.bool,
  }).isRequired,
  className: PropTypes.string,
  adsCounter: PropTypes.number.isRequired,
};
CtnAdDiv.defaultProps = {
  className: 'colombia_spacing',
};

export default CtnAdDiv;
